import { useState } from "react";
import { Share2, Check } from "lucide-react";
import { toast } from "sonner";

export default function ShareButton({ title }) {
  const [copied, setCopied] = useState(false);

  const share = async () => {
    const url = window.location.href;
    if (navigator.share) {
      try { await navigator.share({ title, url }); return; } catch { /* user cancelled */ }
    }
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copied to clipboard");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Could not copy link");
    }
  };

  return (
    <button data-testid="share-button" onClick={share}
      className="inline-flex items-center gap-2 text-sm text-[var(--slate)] hover:text-[#0A1128] transition-colors">
      {copied ? <Check size={16} className="text-[var(--gold)]" /> : <Share2 size={16} />}
      {copied ? "Copied" : "Share"}
    </button>
  );
}
